import type {
  FeatureFlagAdminStoreUser,
  FeatureFlagUserOption,
} from '../../../types/features/featureFlags';

const formatRole = (role: string): string => (
  role
    .trim()
    .replace(/_/g, ' ')
    .replace(/\b\w/g, (letter) => letter.toUpperCase())
);

const getRoleSummary = (user: FeatureFlagAdminStoreUser): string => {
  const roles = Array.from(new Set(
    (Array.isArray(user.stores) ? user.stores : [])
      .map((store) => store.role)
      .filter(Boolean)
      .map(formatRole),
  ));

  return roles.length > 0 ? roles.join(', ') : '-';
};

export const mapAdminStoreUserToFeatureFlagUserOption = (
  user: FeatureFlagAdminStoreUser,
): FeatureFlagUserOption => ({
  id: user.user_id,
  name: user.username || 'Unnamed User',
  ownedStoreCount: user.total_store_count || 0,
  roleSummary: getRoleSummary(user),
  storeNames: (Array.isArray(user.stores) ? user.stores : [])
    .map((store) => store.store_name)
    .filter(Boolean),
});
